module.exports = __webpack_public_path__ + "static/skulk-8fdb91dec85c6d5db1f9a01e869ac912.png";